import type { FaireProductEntity } from "../../entity_types/product";

export const p_zcubstbmbm: FaireProductEntity = {
  token: "p_zcubstbmbm",
  type: "product",
  name: "Raven Figurine",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/00105ec878d95531d49e3b09b3ec878d44cb0c69f13e2cb66eea8de6b38e7eb3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d963f1bec05128874e935f5787daa199eb7f08cfb13acbe40c33e04cce0be34c.jpeg",
    "https://cdn.faire.com/fastly/f2ca79b45952d7b3ff9165daa7d98a03f53599b7e4dd0692c844fba69f8cc0d5.jpeg",
    "https://cdn.faire.com/fastly/b2ddbdd78b044aeedbc7aedef45b71766cf8909f2cca126d6f3e0ad33ee8ba2b.jpeg"
  ],
  priceDollars: 9.5,
  description: "A decorative figurine from our Halloween Collection featuring a rustic design of a raven perched on a twisted tree branch with blue and purple painted accents that coordinates well with seasonal Halloween displays. Our Raven figurine is designed to free stand on flat surface to easily add personality to any home or work space. For decorative use only; this is not a toy. A rustic Halloween home accent with a variety of seasonal display options.",
  tags: [],
  msrpDollars: 18.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:39.183Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
